import { message, Table } from "antd";
import React, { useEffect, useState } from "react";
import API from "../../../services/api-request";
import dayjs from "dayjs";

const PalletHistory = ({ data }) => {
  const [historyData, setHistoryData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);

  const pagination = {
    current: page,
    pageSize: 3,
    total: totalData,
    onChange: (page, limit) => {
      pagination.current = page;
      pagination.pageSize = limit;
      setPage(page);
    },
  };

  const fetchPalletHistory = () => {
    setLoading(true);

    API.Get(`area/${data?.id}/pallet-history?page=${page}&limit=3`)
      .then((res) => {
        const data = res.data.rows;
        setHistoryData(data);
      })
      .catch((err) => {
        console.log(err);
        message.error("Failed to fetch pallet history!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setHistoryData([]);
    fetchPalletHistory();
  }, [data]);

  const columns = [
    {
      title: "No",
      dataIndex: "no",
      key: "no",
      render: (a, b, index) => index + 1,
    },
    {
      title: "No. Pallet",
      dataIndex: "pallet_name",
      key: "pallet_name",
      width: 180,
      sorter: (a, b) => {
        if (a.pallet_name === null || a.pallet_name === "-") return 1;
        if (b.pallet_name === null || b.pallet_name === "-") return -1;
        return a.pallet_name.localeCompare(b.pallet_name);
      },
      render: (pallet_name) => {
        if (pallet_name === null || pallet_name === "-") {
          return "-";
        } else {
          return pallet_name;
        }
      },
    },
    {
      title: "Client",
      dataIndex: "client_name",
      key: "client_name",
      width: 180,
      sorter: (a, b) => {
        if (a.client_name === null || a.client_name === "-") return 1;
        if (b.client_name === null || b.client_name === "-") return -1;
        return a.client_name.localeCompare(b.client_name);
      },
      render: (client_name) => {
        if (client_name === null || client_name === "-") {
          return "-";
        } else {
          return client_name;
        }
      },
    },
    {
      title: "Jenis Produk",
      dataIndex: "product_name",
      key: "product_name",
      width: 180,
      sorter: (a, b) => {
        if (a.product_name === null || a.product_name === "-") return 1;
        if (b.product_name === null || b.product_name === "-") return -1;
        return a.product_name.localeCompare(b.product_name);
      },
      render: (product_name) => {
        if (product_name === null || product_name === "-") {
          return "-";
        } else {
          return product_name;
        }
      },
    },
    {
      title: "Berat Awal",
      dataIndex: "weight_before",
      key: "weight_before",
      width: 180,
      sorter: (a, b) => {
        if (a.weight_before === null || a.weight_before === "-") return 1;
        if (b.weight_before === null || b.weight_before === "-") return -1;
        return a.weight_before.localeCompare(b.weight_before);
      },
      render: (weight_before) => {
        if (weight_before === null || weight_before === "-") {
          return "-";
        } else {
          return Math.round(weight_before) + " Kg";
        }
      },
    },
    {
      title: "Berat Akhir",
      dataIndex: "weight_after",
      key: "weight_after",
      width: 180,
      sorter: (a, b) => {
        if (a.weight_after === null || a.weight_after === "-") return 1;
        if (b.weight_after === null || b.weight_after === "-") return -1;
        return a.weight_after.localeCompare(b.weight_after);
      },
      render: (weight_after) => {
        if (weight_after === null || weight_after === "-") {
          return "-";
        } else {
          return Math.round(weight_after) + " Kg";
        }
      },
    },
    {
      title: "Spesifikasi",
      dataIndex: "specification",
      key: "specification",
      width: 180,
      sorter: (a, b) => {
        if (a.specification === null || a.specification === "-") return 1;
        if (b.specification === null || b.specification === "-") return -1;
        return a.specification.localeCompare(b.specification);
      },
      render: (specification) => {
        if (specification === null || specification === "-") {
          return "-";
        } else {
          return specification;
        }
      },
    },
    {
      title: "Keterangan",
      dataIndex: "note",
      key: "note",
      width: 180,
      sorter: (a, b) => {
        if (a.note === null || a.note === "-") return 1;
        if (b.note === null || b.note === "-") return -1;
        return a.note.localeCompare(b.note);
      },
      render: (note) => {
        if (note === null || note === "-") {
          return "-";
        } else {
          return note;
        }
      },
    },
    {
      title: "Lokasi Awal",
      dataIndex: "area_from",
      key: "area_from",
      width: 180,
      sorter: (a, b) => {
        if (a.area_from === null || a.area_from === "-") return 1;
        if (b.area_from === null || b.area_from === "-") return -1;
        return a.area_from.localeCompare(b.area_from);
      },
      render: (area_from) => {
        if (area_from === null || area_from === "-") {
          return "-";
        } else {
          return area_from;
        }
      },
    },
    {
      title: "Lokasi Tujuan",
      dataIndex: "area_to",
      key: "area_to",
      width: 180,
      sorter: (a, b) => {
        if (a.area_to === null || a.area_to === "-") return 1;
        if (b.area_to === null || b.area_to === "-") return -1;
        return a.area_to.localeCompare(b.area_to);
      },
      render: (area_to) => {
        if (area_to === null || area_to === "-") {
          return "-";
        } else {
          return area_to;
        }
      },
    },
    {
      title: "Pallet Awal",
      dataIndex: "pallet_from",
      key: "pallet_from",
      width: 180,
      sorter: (a, b) => {
        if (a.pallet_from === null || a.pallet_from === "-") return 1;
        if (b.pallet_from === null || b.pallet_from === "-") return -1;
        return a.pallet_from.localeCompare(b.pallet_from);
      },
      render: (pallet_from) => {
        if (pallet_from === null || pallet_from === "-") {
          return "-";
        } else {
          return pallet_from;
        }
      },
    },
    {
      title: "Pallet Tujuan",
      dataIndex: "pallet_to",
      key: "pallet_to",
      width: 180,
      sorter: (a, b) => {
        if (a.pallet_to === null || a.pallet_to === "-") return 1;
        if (b.pallet_to === null || b.pallet_to === "-") return -1;
        return a.pallet_to.localeCompare(b.pallet_to);
      },
      render: (pallet_to) => {
        if (pallet_to === null || pallet_to === "-") {
          return "-";
        } else {
          return pallet_to;
        }
      },
    },
    {
      title: "Operator",
      dataIndex: "operator",
      key: "operator",
      width: 180,
      sorter: (a, b) => {
        if (a.operator === null || a.operator === "-") return 1;
        if (b.operator === null || b.operator === "-") return -1;
        return a.operator.localeCompare(b.operator);
      },
      render: (operator) => {
        if (operator === null || operator === "-") {
          return "-";
        } else {
          return operator;
        }
      },
    },
    {
      title: "Timestamp",
      dataIndex: "timestamp",
      key: "timestamp",
      width: 180,
      sorter: (a, b) => {
        if (a.timestamp === null || a.timestamp === "-") return 1;
        if (b.timestamp === null || b.timestamp === "-") return -1;
        return a.timestamp.localeCompare(b.timestamp);
      },
      render: (timestamp) => {
        if (timestamp === null || timestamp === "-") {
          return "-";
        } else {
          return dayjs(timestamp).format("YYYY-MM-DD hh:mm:ss");
        }
      },
    },
    {
      title: "Action By",
      dataIndex: "action_by",
      key: "action_by",
      width: 180,
      sorter: (a, b) => {
        if (a.action_by === null || a.action_by === "-") return 1;
        if (b.action_by === null || b.action_by === "-") return -1;
        return a.action_by.localeCompare(b.action_by);
      },
      render: (action_by) => {
        if (action_by === null || action_by === "-") {
          return "-";
        } else {
          return action_by;
        }
      },
    },
  ];

  return (
    <Table
      scroll={{ x: 1300 }}
      columns={columns}
      dataSource={historyData}
      rowKey={(dataSource) => dataSource.id}
      loading={loading}
    />
  );
};

export default PalletHistory;
